// extracted by mini-css-extract-plugin
export default {"xs":"576","sm":"640","md":"768","lg":"1024","xl":"1280","2xl":"1600","3xl":"1900","breadCrumbs":"breadcrumbs_breadCrumbs__DrCih"};